import SettingItem from '../../settingItem/SettingItem';
import AddGooglePingItem from '../../addGooglePingItem/AddGooglePingItem';
import {isMaster} from '../../../../functions/permission';
import {useSelector} from 'react-redux';
import MasterPermission from '../../../components/rolePermission/MasterPermission';
import PromotionInLiveSetting, {AutoPromotionBanner} from '../../promotionInLive/PromotionInLiveSetting';

function HubMailingForm() {
    const promotionEventActive = useSelector(s => s.event.settings?.event?.promotionEventActive);

    return (
        <>
            <SettingItem name={'tickchakIndex'}>
                {isMaster() && !promotionEventActive && <SettingItem name={'promotionInTickchak'}/>}
            </SettingItem>
            <SettingItem name={'glatticketIndex'} >
                {isMaster() && !promotionEventActive && <SettingItem name={'promotionInGlatticket'}/>}
            </SettingItem>
            <MasterPermission>
                <SettingItem name={'showInLive'} rowFooter={<AutoPromotionBanner />}>
                    <PromotionInLiveSetting />
                </SettingItem>
            </MasterPermission>

            <SettingItem name={'isIndexed'}>
                <AddGooglePingItem />
            </SettingItem>
            <SettingItem name={'hideFollow'}/>
        </>
    );
}

export default HubMailingForm;
